export enum ActionType {
  FINAL_SCHEDULE_DETAILS_BY_PID = "FINAL_SCHEDULE_DETAILS_BY_PID",
  RESET_REDUX_STATE = "RESET_REDUX_STATE",
}

export interface IFinalScheduleDetailsByPid {
  type: ActionType.FINAL_SCHEDULE_DETAILS_BY_PID;
  payload: any;
}
export interface IResetReduxState {
  type: ActionType.RESET_REDUX_STATE;
}
export type Action = IFinalScheduleDetailsByPid | IResetReduxState;
